import React, { useState, useLayoutEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './assets/css/custom.css';
import Home from './components/Home';
import Preloader from './components/Preloader';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Bloglist from './components/Bloglist';
import Contact from './components/Contact';
import Blog from './components/Blog';
import Jobs from './components/Jobs';
import Category from './components/Category';
import ProductListing from './components/ProductListing';
import Cart from './components/Cart';
import ProductDetails from './components/ProductDetails';
import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import Checkout from './components/Checkout';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';
import Editprofile from './components/Editprofile';
import Order from './components/Order'
import Changepassword from './components/Changepassword'

function App() {
  const { pathname, hash, state } = useLocation();
  const [loading, setLoading] = useState(true);
  const prevPath = React.useRef(null);

  useLayoutEffect(() => {
    const pathChanged = pathname !== prevPath.current;
    if (pathChanged) {
      setLoading(true);
      prevPath.current = pathname;
    }

    let animationTimer;
    const timer = setTimeout(() => {
      setLoading(false);

      // Trigger animations and generic scrolling
      animationTimer = setTimeout(() => {
        // If it's a new page and NOT a state-based scroll, jump to top
        if (pathChanged && !state?.scrollTo) {
          window.scrollTo(0, 0);
        }

        // Global animation triggers
        if (window.animationText) window.animationText();
        if (window.scrollingEffect) window.scrollingEffect();
        if (window.animateImgItem) window.animateImgItem();
        if (window.initHeadline) window.initHeadline();
        if (window.ScrollTrigger) window.ScrollTrigger.refresh();
      }, pathChanged ? 200 : 0);
    }, pathChanged ? 500 : 100);

    return () => {
      clearTimeout(timer);
      clearTimeout(animationTimer);
      if (window.revertAnimations) {
        window.revertAnimations();
      }
      if (window.revertHeadline) {
        window.revertHeadline();
      }
    };
  }, [pathname, hash, state]);

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />
      {loading && <Preloader />}
      <div key={pathname} style={{ display: loading ? 'none' : 'block' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/bloglist" element={<Bloglist />} />
          <Route path="/blog/:slug" element={<Blog />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/item" element={<Category />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/product-details" element={<ProductDetails />} />
          <Route path="/product-listing/:slug" element={<ProductListing />} />
          <Route path="/item-details/:id" element={<ProductDetails />} />
          <Route path="/editprofile" element={
            <ProtectedRoute>
              <Editprofile />
            </ProtectedRoute>
          }
          />
          <Route path="/orderhistory" element={
            <ProtectedRoute>
              <Order />
            </ProtectedRoute>
          } />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/register"
            element={
              <PublicRoute>
                <Register />
              </PublicRoute>
            }
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/changepassword" element={
            <ProtectedRoute>
              <Changepassword />
            </ProtectedRoute>
          }
          />
        </Routes>
      </div>
    </>
  );
}

export default App;
